import API from "utils/APIUtils";


export const getConversationsListAPIHelper = async (params) => {
  try {
    const response = await API.get(`/api/v1/socketio/conversationList`, {
      params,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data || error.message);
  }
};

export const createDirectConversationIdAPIHelper = async (payload) => {
  try {
    const response = await API.post(
      '/api/v1/socketio/chat/conversations',
      payload,
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data || error.message);
  }
};

export const createGroupConversationIdAPIHelper = async (payload) => {
  try {
    const response = await API.post(
      '/api/v1/socketio/group-chat/conversation',
      payload,
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data || error.message);
  }
};

export const sendDirectMessageAPIHelper = async (payload) => {
  try {
    const response = await API.post('/api/v1/socketio/chat/messages', payload);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data || error.message);
  }
};

export const getDirectMessagesAPIHelper = async (params) => {
  try {
    const response = await API.get(
      `/api/v1/socketio/chat/messages/${params?.id}`,
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data || error.message);
  }
};

export const sendGroupMessageAPIHelper = async (payload) => {
  try {
    const response = await API.post(
      '/api/v1/socketio/group-chat/messages',
      payload,
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data || error.message);
  }
};

export const getGroupMessagesAPIHelper = async (params) => {
  try {
    const response = await API.get(
      `/api/v1/socketio/messages/${params.id}`,
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data || error.message);
  }
};
